export function classes(...s: (false | 0 | string | null | undefined)[]) {
  return s
    .filter(Boolean)
    .map((s: any) => s.trim())
    .join(' ');
}

export function padStart(
  value: { toString(): string },
  targetLength: number,
  padString: string
) {
  const self = value.toString();
  targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
  padString = String(typeof padString !== 'undefined' ? padString : ' ');
  if (self.length > targetLength) {
    return String(self);
  } else {
    targetLength = targetLength - self.length;
    if (targetLength > padString.length) {
      padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
    }
    return padString.slice(0, targetLength) + String(self);
  }
}

export function preventBrowserHistorySwipeGestures(callback?: () => void) {
  function touchStart(ev: any) {
    if (ev.touches.length === 1) {
      const touch = ev.touches[0];
      if (
        touch.clientX < window.innerWidth * 0.1 ||
        touch.clientX > window.innerWidth * 0.9
      ) {
        ev.preventDefault();
        callback?.();
      }
    }
  }

  // Safari defaults to passive: true for the touchstart event, so we need  to explicitly specify false
  // See https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
  const options = { passive: false };

  window.addEventListener('touchstart', touchStart, options);

  return () => window.removeEventListener('touchstart', touchStart);
}
